import coverSheet from '../pages/cpf/coverSheet';
import monthlyMetrics from '../pages/cpf/monthlyMetrics';
import type { FormConfig } from '../types';

const formConfig: FormConfig = {
  live: false,
  id: 'cpf',
  formName: 'Common Performance Framework',
  title: 'Common Performance Framework',
  subTitle: 'Quarterly departmental return',
  requiredFlag: true,
  confirmationEmail: true,
  showSections: true,
  identifier: '{cluster} - {contact-email}',
  sections: [
    {
      title: 'Return details',
      slug: 'return-details',
      subsections: [
        { title: 'Before you start and department setup', slug: 'setup', pages: coverSheet },
      ],
    },
    {
      title: 'Performance data',
      slug: 'performance-data',
      subsections: [
        {
          title: 'Monthly metrics and comments',
          slug: 'metrics',
          dependsOn: 'setup',
          pages: monthlyMetrics,
        },
      ],
    },
  ],
};

export default formConfig;
